import type { FieldConfigurationDto } from '@tempo-io/fim3-dto';
import { Select } from '@tempo-io/sui-select';

type Option = { value: string; label: string };

export const MultiSelectFieldInput = ({
  fieldConfiguration,
  values,
  setValues,
  isEditableText,
  disabled,
  autoFocus,
}: {
  fieldConfiguration: FieldConfigurationDto;
  values: string[];
  setValues: (values: string[]) => void;
  isEditableText?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}) => {
  if (fieldConfiguration.fieldType !== 'LIST') return null;

  const options: Option[] = fieldConfiguration.options.map((o) => ({ value: o, label: o }));
  const selectedOptions = options.filter((o) => values.includes(o.value));

  return (
    <Select<Option, true>
      className="fs-exclude"
      data-dd-action-name="FIM 3 Custom Field - multi-select redacted"
      data-testid="fim3-multi-select-input"
      options={options}
      value={selectedOptions}
      onChange={(newValue) => {
        setValues((newValue ?? []).map((o) => o.value));
      }}
      isMulti={true}
      isClearable={false}
      placeholder={isEditableText ? undefined : 'Choose a value'}
      inlineEdit={isEditableText}
      isDisabled={disabled}
      autoFocus={autoFocus}
    />
  );
};
